// extracted by mini-css-extract-plugin
module.exports = {"content":"_1EOlt","image":"_2x5fh"};